export default __webpack_public_path__ + "static/media/store-comp.bb59e2c1.png";